<template>
  <div class="bg-gradient-to-b from-primary-50 to-white to-[50vh] pt-4 sm:pt-8">
    <slot />
  </div>
</template>
